/**
 * Dashboard Recent-Uploads view-mode (Grid vs List). localStorage-persisted
 * presentation preference (NICHT URL-state — kein deep-link-need, dashboard
 * is single-user-personal).
 *
 * Eingeführt in Slice-3 Redesign (2026-05-09). Pattern analog
 * `list-density.ts` (defensive try/catch + Whitelist + Default-Fallback).
 */
export type DashboardRecentView = 'grid' | 'list';

const STORAGE_KEY = 'gf-dashboard-recent-view';
const DEFAULT_VIEW: DashboardRecentView = 'grid';
const VALID: ReadonlySet<DashboardRecentView> = new Set(['grid', 'list']);

/** Defensive read: localStorage kann throwen wenn disabled / private-mode /
 * sandboxed iframe. Try/catch fallback `grid`. Whitelist-Check gegen
 * tampering / schema-drift. */
export function getDashboardRecentView(): DashboardRecentView {
  try {
    const raw = globalThis.localStorage?.getItem(STORAGE_KEY);
    if (raw && VALID.has(raw as DashboardRecentView)) {
      return raw as DashboardRecentView;
    }
    return DEFAULT_VIEW;
  } catch {
    return DEFAULT_VIEW;
  }
}

/** Defensive write: setItem kann throwen bei Quota-full. Silent skip. */
export function setDashboardRecentView(v: DashboardRecentView): void {
  try {
    globalThis.localStorage?.setItem(STORAGE_KEY, v);
  } catch {
    // ignore
  }
}
